import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

//components
import { SbRespRefineMenuStoneCutSelect } from '../SbRespRefineMenuStoneCutSelect/SbRespRefineMenuStoneCutSelect';
import { SbSharedRefineMenuExpandableItemList } from '../../SbSharedRefineMenu/SbSharedRefineMenuExpandableItemList/SbSharedRefineMenuExpandableItemList';

export const SbRespRefineMenuFilterStoneCutComponent = props => {
    const { values, filterName, searchBrowse, isClient } = props;

    return (
        <SbSharedRefineMenuExpandableItemList
            filterName={filterName}
            availableFilterValues={values}
        >
            {({ valuesToShow }) => (
                <SbRespRefineMenuStoneCutSelect
                    isClient={isClient}
                    filterName={filterName}
                    searchBrowse={searchBrowse}
                    valuesToShow={valuesToShow}
                />
            )}
        </SbSharedRefineMenuExpandableItemList>
    );
};

SbRespRefineMenuFilterStoneCutComponent.propTypes = {
    isClient: PropTypes.bool,
    values: PropTypes.array.isRequired,
    filterName: PropTypes.string.isRequired,
    searchBrowse: PropTypes.object.isRequired,
};

export const SbRespRefineMenuFilterStoneCut = createFragmentContainer(
    SbRespRefineMenuFilterStoneCutComponent,
    {
        searchBrowse: graphql`
            fragment SbRespRefineMenuFilterStoneCut_searchBrowse on SearchBrowseQueryConnection {
                ...SbRespRefineMenuStoneCutSelect_searchBrowse
            }
        `,
    }
);
